<div class="relation-table-select">
    <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
    <label class="mat-body-2">{{ label() | transloco }}</label>

    @if (reorderable()) {
        <div class="mb-1">{{ "arrange_drag_drop" | transloco }}</div>
        <div
                cdkDropList
                class="order-list"
                (cdkDropListDropped)="reorder($event)"
        >
            @for (item of selectedItems(); track $any(item)[idKey()]) {
                <div class="order-box" cdkDrag>
                    {{ $any(item)[displayColumn()] }}
                    <button mat-icon-button (click)="removeItem(item)" type="button">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </div>
            }
        </div>
    } @else {
        <div class="chip-list">
            @for (item of selectedItems(); track $any(item)[idKey()]) {
                <mat-chip-row (removed)="removeItem(item)">
                    {{ $any(item)[displayColumn()] }}
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
            }
        </div>
    }

    <button mat-stroked-button type="button" (click)="openDialog()">
        <mat-icon>add</mat-icon>
        {{ "selection" | transloco }}
    </button>
</div>